var _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 3,
    viewBox: "0 0 66 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 1.75,
    rx: 32.5,
    ry: 1,
    fill: "#E5DDF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonShadow);
export default __webpack_public_path__ + "static/media/buttonShadow.c1e4d9932be05e96bc545c90619ab864.svg";
export { ForwardRef as ReactComponent };